/**
 * Component: Sector Cards Carousel
 * Description: Horizontal scroll driven by GSAP ScrollTrigger
 */

import Swiper from 'swiper';
import 'swiper/css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const DESKTOP_BREAKPOINT = 600;

export function sectorCards(carousels) {
  if (!carousels) return;

  carousels.forEach((carousel) => {
    const carouselEl = carousel.querySelector('.swiper');
    const wrapper = carousel.querySelector('.swiper-wrapper');

    if (!carouselEl || !wrapper) return;

    let swiperInstance = null;
    let scrollTween = null;

    /**
     * Initialise Swiper + GSAP ScrollTrigger
     */
    function initDesktopCarousel() {
      if (swiperInstance) return; // already initialised

      swiperInstance = new Swiper(carouselEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        allowTouchMove: false,
        watchSlidesProgress: true
      });

      gsap.set(wrapper, { x: 0 });

      const totalScroll = wrapper.scrollWidth - carouselEl.clientWidth;

      scrollTween = gsap.to(wrapper, {
        x: -totalScroll,
        ease: 'none',
        scrollTrigger: {
          trigger: carouselEl,
          start: 'center-=50 center',
          end: () => `+=${totalScroll}`,
          pin: carousel,
          scrub: 1,
          invalidateOnRefresh: true
        }
      });
    }

    /**
     * Destroy Swiper + ScrollTrigger
     */
    function destroyDesktopCarousel() {
      if (scrollTween) {
        scrollTween.scrollTrigger.kill();
        scrollTween.kill();
        scrollTween = null;
      }

      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }

      gsap.set(wrapper, { x: 0 });
    }

    /**
     * Check viewport and toggle functionality
     */
    function handleResize() {
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        initDesktopCarousel();
      } else {
        destroyDesktopCarousel();
      }
    }

    // Run once on load
    handleResize();

    // Watch for viewport changes
    window.addEventListener('resize', handleResize);
  });
}

